var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPicto = function SvgPicto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 85.039 41.08"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.642 0 67.727 32.512 56.87 0h-6.22L39.67 32.006 25.176 0h-6.631L0 41.08h6.924L21.83 6.807 36.737 41.08h6.049L53.583 9.565 64.264 41.08h7.102L85.039 0z"
  })));
};
export default SvgPicto;